import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/data/http/base-http.service';
import { SearchDeliveryOrdersRequest } from '@core/models/delivery/search-delivery-orders-request';
import { FileMimeType } from '@core/models/file/file-mime-type';
import { Observable } from 'rxjs';
import { SearchRequest } from './search-request';
import { SearchScopeType } from './search-scope-type';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class SearchDataService extends BaseHttpService {
    private urls = {
        search: '/search',
        boards: '/search/boards',
        connections: '/search/connections',
        connectionFilters: '/search/connections/filters',
        deliveries: '/search/deliveries',
        deliveriesFilters: '/search/deliveries/filters',
        ihdSites: '/search/ihdconfig',
        supportDeliveries: '/ihd/search/support/deliveries'
    };

    searchDeliveryOrders(
        request: SearchDeliveryOrdersRequest,
        page: number = 1,
        perPage?: number
    ) {
        let requestURL: string = this.urls.deliveries;

        requestURL = `${requestURL}?page=${page}`;
        if (perPage) {
            requestURL += `&per_page=${perPage}`;
        }

        return this.post(requestURL, request);
    }

    searchSupportDeliveryOrders(
        request: SearchDeliveryOrdersRequest,
        page: number = 1,
        perPage?: number
    ) {
        let requestURL: string = environment.api.endpointBase + this.urls.supportDeliveries;

        requestURL = `${requestURL}?page=${page}`;
        if (perPage) {
            requestURL += `&per_page=${perPage}`;
        }

        return this.post(requestURL, request, undefined, true);
    }

    exportDeliveryOrders(
        request: SearchDeliveryOrdersRequest,
        mimeType: FileMimeType = FileMimeType.CSV
    ) {
        let requestURL: string = this.urls.deliveries;

        let acceptType: string;

        if (mimeType === FileMimeType.CSV) {
            acceptType = 'application/csv';
        } else if (mimeType === FileMimeType.XLSX) {
            acceptType = 'application/vnd.ms-excel';
        }

        const options = {
            headers: new HttpHeaders().set('Accept', acceptType),
            responseType: 'arraybuffer',
        };

        return this.post(requestURL, request, options);
    }

    fetchDeliveryOrderFilters() {
        return this.get(this.urls.deliveriesFilters);
    }

    /**
     * Base search request.
     * @param request
     * @returns {Observable<Response>}
     */
    search(request: SearchRequest): Observable<any> {
        const requestURL: string = this.urls.search + this.toQueryParams(request);
        return this.get(requestURL);
    }

    /**
     * Search companies.
     * @param keywords
     * @param page
     * @returns {Observable<any>}
     */
    searchCompanies(keywords: string, page?: number): Observable<any> {
        const searchRequest = new SearchRequest(
            SearchScopeType.COMPANIES,
            keywords
        );

        if (page) {
            searchRequest.page = page;
        }

        return this.search(searchRequest);
    }

    searchIHDSites(query: string) {
        const requestURL: string = this.urls.ihdSites + this.toQueryParams({ q: query });
        return this.get(requestURL);
    }
}
